import React from 'react';
import { AuthContext, IAuthContext } from 'site/components/auth/AuthProvider';
import { GetMyAccountQuery } from 'site/graphql';

export type IGetMyAccountState = {
    account: GetMyAccountQuery['myAccount'];
    isFetching: boolean;
    setState: IAuthContext['setState'];
    isLoggedIn: IAuthContext['isLoggedIn'];
};

export default function withAuthContext(Component) {
    return function WrapperComponent(props) {
        return (
            <AuthContext.Consumer>
                {state => (
                    <Component
                        {...props}
                        account={state.myAccount}
                        isFetching={state.loading}
                        setState={state.setState}
                        isLoggedIn={state.isLoggedIn}
                    />
                )}
            </AuthContext.Consumer>
        );
    };
}
